import axiosInstance from '../axios';
import { getLoginToken } from '../storage';
import { BaseUrl } from '../config';
import { firebase } from '../firebase-config';
import { collection, getDocs, query, where, doc, setDoc } from 'firebase/firestore';
const moment = require("moment");

const defaultHeaders = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  withCredentials: true,
};

export async function acuitygetEmployees(formData, onSuccess, onError) {
  const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
  try {
    const res = await axiosInstance.get(`${BaseUrl}acuitygetEmployees`, {
      params: { ...formData },
      headers: { ...defaultHeaders, ...authHeaders },
    });
    // console.log(res);
    onSuccess && onSuccess(res);
  } catch (res_1) {
    onError && onError(res_1);
  }
}

/**
 * Get Appontments list from acuity throu cloud function
 * @param {*} formData : may be use to pass data for filter
 * @param {*} onSuccess
 * @param {*} onError
 */
export async function acuitygetAppointments(formData, onSuccess, onError) {
  const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
  try {
    const res = await axiosInstance.get(
      `${BaseUrl}acuitygetAppointmentsAdminnew`,
      {
        params: { ...formData },
        headers: { ...defaultHeaders, ...authHeaders },
      }
    );

    let resultsStore = [];
    const colRef = collection(firebase, "timesheets");
    const appointmentQuery = query(colRef, where("appointmentDate", "in", [moment(formData.minDate).format("MMMM D, YYYY")]));

    const querySnapshot = await getDocs(appointmentQuery);
    querySnapshot.forEach((doc) => {
      let data = doc.data();
      resultsStore.push({ id: doc.id, ...data });
    });

    const resData = res?.data?.data;
    const cancelledAppts = [];
    const filterData = resData?.filter((acuityAppt) => {
      const findEle = resultsStore.find(
        (storeAppt) => {
          if (storeAppt?.apoointmentDetails?.canceled) {
            cancelledAppts.push(storeAppt.id);
          }
          return acuityAppt.id.toString() === storeAppt.appointmentId.toString();
        }
      );

      if (findEle) {
        if (acuityAppt?.noShow) {
          cancelledAppts.push(findEle.id);
        }
        return false;
      }
      if (acuityAppt?.noShow) return false;

      return true;
    });

    cancelledAppts?.map((storApptId) => {
      const refToDel = doc(colRef, storApptId); // Create a document reference for deletion
      setDoc(refToDel, {}, { merge: true }); // Use merge to avoid deleting the document outright
      return storApptId;
    });

    // Optimize: Batch fetch all unique calendar IDs and client names to avoid N+1 queries
    const uniqueCalendarIds = [...new Set(filterData.map(a => [a.calendarID, a.calendarID.toString()]).flat())];
    const uniqueClientNames = [...new Set(filterData.map(a => ({
      firstName: a.firstName?.trim() || "",
      lastName: a.lastName?.trim() || "",
      clientName: a.firstName?.trim() || ""
    })))];

    // Batch fetch all employees
    const employeeMap = new Map();
    if (uniqueCalendarIds.length > 0) {
      // Firestore 'in' queries are limited to 10 items, so batch them
      const batches = [];
      for (let i = 0; i < uniqueCalendarIds.length; i += 10) {
        const batch = uniqueCalendarIds.slice(i, i + 10);
        batches.push(batch);
      }
      
      const employeeQueries = batches.map(batch => 
        getDocs(query(
          collection(firebase, "users"),
          where("acuityId", "in", batch)
        ))
      );
      
      const employeeSnapshots = await Promise.all(employeeQueries);
      employeeSnapshots.forEach(snapshot => {
        snapshot.forEach((doc) => {
          const data = doc.data();
          employeeMap.set(data.acuityId, { id: doc.id, ...data });
        });
      });
    }

    // Batch fetch all clients (optimize by fetching unique combinations)
    const clientMap = new Map();
    const clientQueries = [];
    
    // Create queries for firstName/lastName combinations
    const nameCombos = uniqueClientNames.filter(c => c.firstName && c.lastName);
    if (nameCombos.length > 0) {
      // Note: Firestore doesn't support OR queries easily, so we'll batch by firstName
      const firstNameGroups = {};
      nameCombos.forEach(c => {
        if (!firstNameGroups[c.firstName]) {
          firstNameGroups[c.firstName] = [];
        }
        firstNameGroups[c.firstName].push(c.lastName);
      });
      
      // For each firstName, query and filter by lastName in memory
      for (const [firstName, lastNames] of Object.entries(firstNameGroups)) {
        clientQueries.push(
          getDocs(query(
            collection(firebase, "clientsNew"),
            where("firstName", "==", firstName)
          )).then(snapshot => {
            const clients = [];
            snapshot.forEach((doc) => {
              const data = doc.data();
              if (lastNames.includes(data.lastName)) {
                const key = `${data.firstName}_${data.lastName}`;
                clientMap.set(key, { id: doc.id, ...data });
                clients.push({ id: doc.id, ...data });
              }
            });
            return clients;
          })
        );
      }
    }

    // Also fetch by clientName for fallback
    const clientNameSet = new Set(uniqueClientNames.map(c => c.clientName).filter(Boolean));
    if (clientNameSet.size > 0) {
      const clientNameBatches = [];
      const clientNameArray = Array.from(clientNameSet);
      for (let i = 0; i < clientNameArray.length; i += 10) {
        clientNameBatches.push(clientNameArray.slice(i, i + 10));
      }
      
      clientNameBatches.forEach(batch => {
        clientQueries.push(
          getDocs(query(
            collection(firebase, "clientsNew"),
            where("clientName", "in", batch)
          )).then(snapshot => {
            snapshot.forEach((doc) => {
              const data = doc.data();
              const key = `name_${data.clientName}`;
              if (!clientMap.has(key)) {
                clientMap.set(key, { id: doc.id, ...data });
              }
            });
          })
        );
      });
    }

    await Promise.all(clientQueries);

    await Promise.all(filterData.map(async (appointmentData) => {
      // Use pre-fetched employee data
      const employee = employeeMap.get(appointmentData.calendarID) || 
                       employeeMap.get(appointmentData.calendarID.toString()) || 
                       null;

      if (employee) {
        // Use pre-fetched client data
        const clientKey = appointmentData.firstName && appointmentData.lastName
          ? `${appointmentData.firstName.trim()}_${appointmentData.lastName.trim()}`
          : `name_${appointmentData.firstName?.trim()}`;
        
        let clients = [];
        const client = clientMap.get(clientKey);
        if (client) {
          clients = [client];
        } else {
          // Fallback: try clientName lookup
          const fallbackClient = clientMap.get(`name_${appointmentData.firstName?.trim()}`);
          if (fallbackClient) {
            clients = [fallbackClient];
          }
        }

        if (clients.length > 0 && !appointmentData?.noShow) {
          const clientData = clients[0];
          const shiftFields = appointmentData.forms[0].values;
          let ShiftName = "Morning";
          shiftFields.forEach((item) => {
            if (item.name.trim() === "ShiftName" || item.name.trim() === "Shift Name") {
              ShiftName = item.value;
            }
          });

          let clientShiftData = {};
          let ShiftId = "";
          for (let shiftDataKey in clientData.shiftData) {
            const shiftData = clientData.shiftData[shiftDataKey];
            for (let shift in shiftData) {
              if (shiftData[shift].title === ShiftName) {
                ShiftId = shiftDataKey;
                clientShiftData = { ...clientShiftData, ...shiftData };
              }
            }
          }

          let finalResult = [];
          const finalQuery = query(colRef, where("appointmentId", "in", [
            appointmentData.id,
            appointmentData.id.toString(),
          ]));

          const finalSnapshot = await getDocs(finalQuery);
          finalSnapshot.forEach((doc) => {
            let data = doc.data();
            finalResult.push({ id: doc.id, ...data });
          });

          let timeSheetData = {
            appointmentId: appointmentData.id.toString(),
            clientId: clients[0].id,
            email: employee[0].email,
            isWorking: false,
            completed: false,
            lastUpdatedAt: firebase.FieldValue.serverTimestamp(),
            location: { lat: 32.0, lng: 32.0 },
            shiftId: ShiftId,
            tasks: clientShiftData,
            userId: employee[0].id,
            appointmentDateTime: appointmentData.datetime,
            appointmentDate: appointmentData.date,
            appointmentDuration: appointmentData.duration,
            apoointmentDetails: appointmentData,
          };

          if (finalResult.length > 0) {
            await setDoc(doc(colRef, finalResult[0].id), timeSheetData);
          } else {
            const id = `${timeSheetData.appointmentId}-${timeSheetData.clientId}-${timeSheetData.shiftId}-${timeSheetData.userId}-${new Date().toISOString().split("T")[0]}`;
            timeSheetData.createdAt = firebase.FieldValue.serverTimestamp();
            await setDoc(doc(colRef, id), timeSheetData, { merge: true });
          }
        }
      }
    }));

    onSuccess && onSuccess(res);

  } catch (res_1) {
    console.log("res_1>>", res_1);
    onError && onError(res_1);
  }
}
